import React, { useState, useEffect,useMemo } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { event } from 'jquery';
import Select from 'react-select';
import getDecryptData from '../../../helpers/getDecryptData';
import { triggerChooseimg } from "../../components/ChooseImg";
import Gallery from "../../components/Gallery";
import { useThemeContext } from '../../../fetchdata/ThemeContext';
import SlotsSimple from '../../components/SlotsSimple';
import { SchedulePickerToast } from '../../components/SchedulePickerToast';

 
  

const OrderCreateAppointment = () => {
 
  const navigate = useNavigate();
   const { id } = useParams();

 const  {getAuth , sendMessage, allMessages} = useThemeContext();

  const [addHistory, setAddHistory] = useState([]);
      //  const [commentStatus, setCommentStatus] = useState(false);
       const [commentEmployee, setCommentEmployee] = useState(null);
       const [MyComment, setMyComment] = useState('');



const SubmitHistory = async (changes, comment, id, working, days, date) => {
  const now = new Date();
  const decryptdatajson = getDecryptData();

  const baseDate = date ? new Date(date) : new Date(); // Use provided date or now
  const dayCount = parseInt(days); // Convert days to number (if possible)

  if (!isNaN(dayCount) && dayCount > 0) {
    // Loop for 'days' number of times
    const newHistories = [];

    for (let i = 0; i < dayCount; i++) {
      const loopDate = new Date(baseDate);
      loopDate.setDate(baseDate.getDate() + i); // Add days

      const updatedHistory = {
        date: loopDate.toLocaleDateString(), // e.g., 5/1/2025
        time: now.toLocaleTimeString(),      // keep time the same
        userId: decryptdatajson._id,
        name: decryptdatajson.username,
        phone: decryptdatajson.phone,
        changes,
        comment,
        assignId: id || null,
        working: working || '',
      };

      newHistories.push(updatedHistory);
    }

    setAddHistory(prev => [...prev, ...newHistories]);
    console.log('Added multiple updatedHistory entries:', newHistories);
  } else {
    // Single entry fallback
    const updatedHistory = {
      date: baseDate.toLocaleDateString(),
      time: now.toLocaleTimeString(),
      userId: decryptdatajson._id,
      name: decryptdatajson.username,
      phone: decryptdatajson.phone,
      changes,
      comment,
      assignId: id || null,
      working: working || '',
    };

    setAddHistory(prev => [...prev, updatedHistory]);
    console.log('Added single updatedHistory:', updatedHistory);
  }
};



    
       const handleChangeComment = () => {
        if(!formData.formcomment || formData.formcomment === ''  ){
          toast.error('Please type comment');
        }else{
    
          if( !formData.working || formData.working === '' ){
          toast.error('Please Choose Working Status');
          }else{
        if(!formData.workingdate && formData.working !== '2'){
          toast.error('Please Choose date');
  return null;
        }
          
      SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment} - ${formData.working === '1' && 'working' ||  formData.working === '0'  && 'On leave'  ||  formData.working === '2'  && 'Left job'}`,formData.employeeId,formData.working,formData.working === '2' ? 1 : formData.workingdays ,formData.workingdate);
          
      if (formData.workingdays &&  formData.working === '0') {
 
          const pickupDate = new Date(formData.PickupDate);
  const returnDate = new Date(formData.ReturnDate);
  const diffTime = returnDate - pickupDate;
  const diffDays = diffTime / (1000 * 3600 * 24);

  const extraDays = Number(formData.workingdays);
  const totalDays = diffDays + extraDays + 1;

  console.log('Base diffDays: ' + diffDays);
  console.log('Extra days: ' + extraDays);
  console.log('Total days: ' + totalDays);

  const returnValue = addDaysToDate(formData.PickupDate, totalDays);

  setFormData((prevData) => ({
    ...prevData,
    ReturnDate: returnValue,
    diffDays: totalDays,
  }));
  
 
 }

// setCommentStatus(false);
            setFormData((prevData) => ({
            ...prevData,
            'formcomment': null,
            'working' : null,
            
          }));
  
          }
     
        }
    
      }
  

  const [AllProducts, setAllProducts] = useState([]);

  const getUserAllPro = async () => {
    try {
      
      if(id === '3' ){
       setAllProducts([
        {
            "_id": "1234567890",
            "title": "Appointment Consultation",
            "slug": "appointment_consultation",
            "regularPrice": null,
            "salePrice": 0,
            "stock": 100,
            "reStock": 100,
            "serialNumber": 1,
            "brandName": "Appointment Consultation",
            "protype": 1,
            "gst": 12,
            "Rentalgst": 12
        }])  

        setAddProduct( [    {
    "_id": "1234567890",
    "title": "Appointment Consultation",
    "slug": "appointment_consultation",
    "regularPrice": null,
    "salePrice": 0,
    "stock": 100,
    "reStock": 100,
    "serialNumber": 1,
    "brandName": "Appointment Consultation",
    "protype": 1,
    "gst": 12,
    "Rentalgst": 12,
    "quantity": 1,
    "amount": 0,
    "total": 0,
    "tax": 12
}] )
            



      }else{
              const response = await axiosInstance.get(`/all-products?type=1`);

        setAllProducts(response.data.products);
        console.log('setAllProducts', response.data.products)

      }
  
    } catch (error) {
        console.error('Error fetching user products:', error);
    } 
};



  const [AllUser, setAllUser] = useState([]);
  const [AddProduct, setAddProduct] = useState([]);

  const [AddRental, setAddRental] = useState([]);
  const [AddReceived, setAddReceived] = useState([]);
  const [AddReturn, setAddReturn] = useState([]);


  const [UserId, setUserId] = useState(null);
  const [AllEmployee, setAllEmployee] = useState([]);
    const [AllProEmployee, setAllProEmployee] = useState([]);

    const [departments, setDepartments] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);

	  const [AllHosEmployee, setAllHosEmployee] = useState([]);


  const [AllSaleEmployee, setAllSaleEmployee] = useState([]);


  const [UserDetails, setUserDetails] = useState({});

  
  const [OrderId, setOrderId] = useState(null);


    const [formData, setFormData] = useState({
      source:'',
    });
  
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0); // Default discount is 0
    const [shipping, setShipping] = useState(0); // Default discount is 0
    const [finalTotal, setFinalTotal] = useState(0);
    const [taxTotal, setTaxTotal] = useState(0);

    const [applyIGST, setApplyIGST] = useState(false);
    const [applyCGST, setApplyCGST] = useState(false);
    const [applySGST, setApplySGST] = useState(false);

    const handleClearClick = () => {
      setSearchQuery("");
    };

    const handleDiscountChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setDiscount(value);
    };

    const handleShippingChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setShipping(value);
    };
    
    const handleAddProduct_old = (product) => {
          if (id === '1' && product.stock <= 0) {
              toast.error('Product is out of stock');
              return null;   
            }else if( product.reStock <= 0){
              toast.error('Product is out of stock');
              return null;  
            }
            console.log('product',product)
      let ProductCost = 0;
      if(product){
        ProductCost = product.salePrice;
      }
     
      const updatedProduct = {
        ...product,
        quantity: 1,
        amount: ProductCost,
        total: ProductCost,
       tax: id === '1' ? product.gst : product.Rentalgst || 0 ,
      };
      setAddProduct([...AddProduct, updatedProduct]);
      setSearchQuery("");
    };

const filterEmployeesByProduct = (product) => {
  return AllProEmployee
    .filter(emp => {
      /** -------- Department Match -------- */
      const deptMatch =
        !product.department ||
        (Array.isArray(emp.department) &&
          emp.department.includes(product.department));

      /** -------- Sub-Department Match -------- */
      const subDeptMatch =
        !Array.isArray(product.subdepartment) || // product has no sub-dept restriction
        !Array.isArray(emp.subDepartments) ||     // employee can serve all
        product.subdepartment.some(sub =>
          emp.subDepartments.includes(sub)
        );

      return deptMatch && subDeptMatch;
    })
    .map(emp => ({
      value: emp._id,
      label: emp.username,
      data: emp,
    }));
};



// const handleEmployeeChange = async (index, selectedOption) => {
//   console.log('selectedOption',selectedOption);
//   const employeeId = selectedOption?.value;
//   const schedule = await FetchDoctorBookChange(employeeId);
// console.log(schedule);
//   const updated = [...AddProduct];
//   updated[index].date = date;
//   updated[index].time = time;
//   updated[index].employee = selectedOption;
//   updated[index].employeeId = employeeId;
//   setAddProduct(updated);
// };

function to24Hour(t) {
  let [time, modifier] = t.trim().split(" ");
  let [hours, minutes] = time.split(":");

  hours = parseInt(hours, 10);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
}


const handleEmployeeChange = async (index, selectedOption) => {
  const employeeId = selectedOption?.value;
  const employee = selectedOption?.data;

  console.log('selectedOption',selectedOption);
  if (!employeeId) {
    toast.error("Please select an employee");
    return;
  }

  const scheduleList = await FetchDoctorBookChange(employeeId);

  toast.custom((t) => (
    <SchedulePickerToast
      t={t}
      scheduleList={scheduleList}
      employeeId={employeeId}
      employee={employee}
      employeeName={selectedOption?.label}
      onConfirm={({ date, time }) => {
        const updated = [...AddProduct];
const [start, end] = time.split("-");

const startTime24 = to24Hour(start);
const endTime24 = to24Hour(end);

        // ✅ choose date/time first, then update index
        updated[index] = {
          ...updated[index],
          date,
          time : (employee?.type === 1 && employee?.empType === 3) ?  time : '' ,
          startTime: (employee?.type === 1 && employee?.empType === 3) ? startTime24 : '',
          endTime: (employee?.type === 1 && employee?.empType === 3) ? endTime24 : '',
          employee: selectedOption,
          employeeId,
          doctor:  (employee?.type === 1 && employee?.empType === 3) ? 1 : 0,
        };

        setAddProduct(updated);
        toast.success("Date & time selected");
        console.log('Date & time selected',updated)
      }}
    />
  ),
  {
    duration: Infinity, // ✅ important: no auto-hide
  });
};

const handleAddProduct = (product) => {
  // if (id === '1' && product.stock <= 0) {
  //   toast.error('Product is out of stock');
  //   return;
  // }

  const employeeOptions = filterEmployeesByProduct(product);


  const updatedProduct = {
    ...product,
    quantity: 1,
    amount: product.salePrice,
    total: product.salePrice,
    tax: id === '1' ? product.gst : product.Rentalgst || 0,
    employeeOptions,
    status:0,
  };

  setAddProduct(prev => [...prev, updatedProduct]);
  setSearchQuery("");
};

    

      const handleAddRental = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
          };
    
          setAddRental([...AddRental, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
    
        const handleAddReceived = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }

        if(id === '4' && !formData.days){ 
       toast.error('No. of days is required');
       return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
            days : formData.days,
          };
    
          setAddReceived([...AddReceived, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
    
        const handleAddReturn = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
          };
    
          setAddReturn([...AddReturn, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
        
        const handleEditRental = (index) => {
          const selectedData = AddRental[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',

            raindex: index
          }));
        };
    
            
        const handleEditReceived = (index) => {
          const selectedData = AddReceived[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',
            days: selectedData.days || '',
            raindex: index
          }));
        };
    
        const handleEditReturn = (index) => {
          const selectedData = AddReturn[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',
            raindex: index
          }));
        };

    
    const ResetRentalInputs = () => {
      setFormData((prevData) => ({
        ...prevData,
        raDate: '',
        raTime: '',
        raGateway: '',
        raAmount: '',
        raMethod: '',
        raTransaction: '',
      }));

    }


      // product Features
      const [Features, setFeatures] = useState([]);
    
      const addFeatures = () => {
        const newFeatures = (
          <div key={Features.length} className="col-md-12 mb-2 d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Type Prescription"
              id={`Features${Features.length}`}
            />
    
            <button
              className="btn btn-danger d-block m-auto"
              onClick={removeFeatures}
            >
              Delete
            </button>
            <br />
          </div>
        );
    
        const updatedFeatures = [...Features, newFeatures];
        setFeatures(updatedFeatures);
      };
    
      const removeFeatures = (event) => {
        const button = event.target;
        const parentDiv = button.parentNode; // Accessing the parent div
        parentDiv.remove(); // Remove the parent div
      };
    
       const [imageDivs, setImageDivs] = useState([]);
      
        const addImageDiv = () => {
          const newImageDiv = (
            <div key={imageDivs.length} className={`col-md-3 col-6`}>
              <div className={`input-group imageupload-bx mb-3`}>
                <img
                  className="image-preview"
                  src="/assets/images/placeholder.png"
                  alt="Preview"
                  id={`imageinput${imageDivs.length}`}
                  data-bs-toggle="modal"
                  data-bs-target="#modal-default"
                />
                <input
                  type="hidden"
                  className="form-control imageopen"
                  id={`imageproduct${imageDivs.length}`}
                  name="productImg[]"
                  value="/assets/images/placeholder.png"
                />
              </div>
              <button
                className="btn btn-danger d-block m-auto"
                onClick={removeImageDiv}
              >
                Delete
              </button>
              <br />
            </div>
          );
      
          const updatedImageDivs = [...imageDivs, newImageDiv];
          setImageDivs(updatedImageDivs);
          setTimeout(function () {
            triggerChooseimg();
          }, 1);
        };
      
        const removeImageDiv = (event) => {
          const button = event.target;
          const parentDiv = button.parentNode; // Accessing the parent div
          parentDiv.remove(); // Remove the parent div
        };
      
 
     const handleUpdateRental = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddRental];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           setAddRental(updatedData);
        }
        const handleUpdateReceived = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddReceived];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           updatedData[index].days =  formData.days; 

           setAddReceived(updatedData);
        }
    
        const handleUpdateReturn = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddReturn];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           setAddReturn(updatedData);
        }


    const handleRemoveRental = (index) => {
      const updatedData = [...AddRental];
      updatedData.splice(index, 1);
      setAddRental(updatedData);
    };


    const handleRemoveReceived = (index) => {
      const updatedData = [...AddReceived];
      updatedData.splice(index, 1);
      setAddReceived(updatedData);
    };

    const handleRemoveReturn = (index) => {
      const updatedData = [...AddReturn];
      updatedData.splice(index, 1);
      setAddReturn(updatedData);
    };

    
    const handleRemoveProduct = (index) => {
      const updatedProducts = [...AddProduct];
      updatedProducts.splice(index, 1);
      setAddProduct(updatedProducts);
    };

    const handleTitleChange = (index, value) => {
      const updatedProducts = [...AddProduct];
       const title = value;     
       updatedProducts[index].title = title;
      setAddProduct(updatedProducts);
      // SubmitHistory('Update Product Title', 'None');
    };

    
    const handleQuantityChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const quantity = parseInt(value) || 1;
      const price = updatedProducts[index].amount || 0;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].quantity = quantity;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

    const handleSerialNumberChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const serialNumber = value; 
      updatedProducts[index].serialNumber = serialNumber;
       setAddProduct(updatedProducts);
    };
    


    const handleAmtChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const newAmount = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].amount = newAmount;
      updatedProducts[index].total = quantity * newAmount * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

    const handleTaxChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const tax = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const price = updatedProducts[index].amount || 0;
    
      updatedProducts[index].tax = tax;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

      const [searchQuery, setSearchQuery] = useState("");
    
      const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
      };
    
  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const filteredProducts = AllProducts?.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleUserChange = (userId) => {
     const selectedUser = AllUser.find((user) => user._id === userId);
     console.log('AllUser',userId, AllUser)

    if (selectedUser) {
      setUserDetails({
        id: selectedUser._id,
        name: selectedUser.username,
        email: selectedUser.email,
        phone: selectedUser.phone,
      });
     }
  };
  
  

        const [clinicData, setClinicData] = useState({});

       const [allSchedule, setAllSchedule] = useState([]);
   
            const [loadingSchedule, setLoadingSchedule] = useState(false);
   
   const FetchDoctorBookChange = async (myid) => { 
      try {
     
        setLoadingSchedule(true);
       const response = await axiosInstance.get(`/get-vendor-slot?doc=${myid}&days=10&hos=${formData.hospitalId}`);
       const { success, schedule } = response.data;
       if (success) {
      setAllSchedule(schedule ?? []);
         } 

         const myschedule = schedule ?? [];
        return myschedule;
     } catch (error) {
       console.error('Error fetching bookings:', error);
   
     }finally{
      setLoadingSchedule(false);
     }
    
   };
   

const handleChange = (e) => {
    const { name, value, type, checked,label ,schedule } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    } 

   
    if(name === 'PickupDate' &&  formData.days){
   
       const dateValue = newValue;
       const returnvalue =  addDaysToDate(dateValue, formData.days);
       console.log('returnvalue',returnvalue);
       console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
       setFormData((prevData) => ({
        ...prevData,
        'ReturnDate': returnvalue,
      }));
      
    }
     else if (name === "employeeId" ) {
      newValue = value;
      // SubmitHistory('Update Employee ( Doctor / Nurse / Runner )', `username : ${label}`);
      // setCommentStatus(true);
      setCommentEmployee(label);
      setMyComment('Update Employee ( Doctor / Nurse / Runner )');
      setClinicData(schedule ?? {});
     console.log('schedule',schedule);
       FetchDoctorBookChange(value);
       setFormData((prevData) => ({
      ...prevData,
       currentRange: 0,
    }));


    } else if (name === "department") {
    // frontend department filter here 👇
    newValue = value;

    // 1) save in formData (or filterInputs)
    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
      employeeId: null,

    }));

    // 2) filter employees according to selected department
    if (!newValue) {
      // if cleared, show all again
      setFilteredEmployees(AllEmployee);
    } else {
      const filtered = AllEmployee.filter((emp) => {
        // emp.subDepartments is Array in your schema
        if (Array.isArray(emp.subDepartments)) {
          return emp.subDepartments.includes(newValue);
        }
        return false;
      });

      setFilteredEmployees(filtered);
    }

    // important: stop here so the rest of the function doesn't run again
    return;
  }
    
    if (name === "days" ) {
      let myvalue;
      if(1 > newValue ){
        myvalue = 1
      }else{
        myvalue = newValue;
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: myvalue,
      }));

if(formData.PickupDate){
  const returnvalue =  addDaysToDate(formData.PickupDate, myvalue);
  console.log('returnvalue',returnvalue);
  console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
  setFormData((prevData) => ({
   ...prevData,
   'ReturnDate': returnvalue,
 }));
}
     
     
    }else{
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    }
  
   };

  const handleUserDataChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }

     if(name === 'phone'){
      fetchUserPhoneData(newValue);
     }

    setUserDetails((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };
  

// const selectUser = async (OrderId, User,cat,type,distance) => {
//   fetchemployeeData(cat,type,distance);
//   setOrderId(OrderId);
//   setUserId(User);
//  }
 

const fetchUserPhoneData = async (phone) => {
  if(phone.length === 10){
  
   try {
    const response = await axiosInstance.get(`/all-employee?&type=none&filter=none&phone=${phone}`);
    const { success, Users } = response.data;
    if (success) {
      if(Users && Users[0]){
        const data = Users[0];
        setUserDetails({
          id: data._id,
          name: data.username || '',
          email: data.email || '',
          phone: data.phone || '',
          address: data.address,
          gender: data.gender || '',
          company: data.company,
          companyName: data.companyName,
          companyGST: data.companyGST,
          companyAddress: data.companyAddress,
          age: data.age,
          weight: data.weight,
        });
      }
      toast.success('User Found');
      console.log('Users',response.data);
      }else{
        toast.success('New User Found');
        setUserDetails({
          id: 'none',
          name:'',
          email: '',
          address: '',
          gender: '',
          phone : phone,
        });
      }

  } catch (error) {
    console.error('Error fetching User:', error);

  }
  
}

};


const fetchSaleEmployeeData = async () => {

  setAllSaleEmployee
  ([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&empType=4&filter=2&headId=${formData.hospitalId}`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllSaleEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

const fetchHosEmployeeData = async () => {

  setAllHosEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&empType=2`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllHosEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

const fetchEmployeeData = async () => {

  if(!getAuth._id) return;

  if(getAuth.headId && getAuth.headId[0]){
      setFormData((prevData) => ({
        ...prevData,
       hospitalId: getAuth.headId[0],
       }));
  }
  setAllEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&empType=3&department=true&headId=${formData?.hospitalId}`);
    const { success, Users,subDepartments } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllEmployee(Users);
      setDepartments(subDepartments || [])
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

 
const fetchAllEmployeeData = async () => {
 
  setAllProEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?onlytype=1&notemptype=2&headId=${formData?.hospitalId}`);
    const { success, Users } = response.data;
    if (success) {
       setAllProEmployee(Users);
   }

  } catch (error) {
    console.error('Error fetching User:', error); 
  }

};
 

  const getUserOrders = async () => {

    try {

       // const { data } = await axiosInstance.get(`/user-orders-view/${userId}/${orderId}`);

      // if (data?.success) {
      //   console.log('order', data)
      //   setOrder(data?.userOrder);

      // }
      // setIsLoading(false);  

    } catch (error) {
    //  console.log(error);
     // setIsLoading(false); // Set loading state to false in case of an error
    //  toast.error("order Not found");
   
    }
  };

  useEffect(() => {
     getUserOrders();
getUserAllPro();
fetchSaleEmployeeData();
fetchHosEmployeeData();

  }, []);

    useEffect(() => {
 if(formData.hospitalId){
fetchSaleEmployeeData();
fetchAllEmployeeData();
 }  
  }, [formData.hospitalId]);

  useEffect(() => {
if(getAuth && getAuth.length !== 0 ){
      fetchEmployeeData();

}

  }, [getAuth]);

    useEffect(() => {
       if(addHistory){
        console.log('addHistory',addHistory)
       }
    }, [addHistory]);
  
   
    useEffect(() => {
    if (addHistory.length > 0) {
      // --- STEP 1: Deduplicate by assignId + date ---
      const seenMap = new Map();
      const dedupedHistory = [...addHistory];
  
      for (let i = 0; i < dedupedHistory.length; i++) {
        const entry = dedupedHistory[i];
        const { assignId, date, working } = entry;
  
        if (assignId && date && working !== "") {
          const key = `${assignId}_${date}`;
  
          if (seenMap.has(key)) {
            const prevIndex = seenMap.get(key);
            dedupedHistory[prevIndex] = entry; // keep latest
            dedupedHistory[i] = null;          // remove older
          } else {
            seenMap.set(key, i);
          }
        }
      }
  
      const filteredHistory = dedupedHistory.filter(e => e !== null);
  
      // --- STEP 2: Remove entries AFTER "left job" ---
      const finalList = filterAfterLeftJob(filteredHistory);
  
      // --- STEP 3: Update state if changed ---
      const isDifferent = JSON.stringify(addHistory) !== JSON.stringify(finalList);
      if (isDifferent) {
        setAddHistory(finalList);
      }
    }
  }, [addHistory]);
  
  
  // External helper
  function filterAfterLeftJob(data) {
    const leftJobEntry = data.find(
      (entry) => entry.working === "2" && entry.assignId && entry.userId
    );
  
    if (!leftJobEntry) return data;
  
    const { assignId, userId, date: leftDate } = leftJobEntry;
  
    const parseDate = (str) => new Date(Date.parse(str));
  
    return data.filter((entry) => {
      if (
        entry.assignId === assignId &&
        entry.userId === userId &&
        entry.working !== "" &&
        entry.working !== "2"
      ) {
        const entryDate = parseDate(entry.date);
        const leftJobDate = parseDate(leftDate);
        return entryDate <= leftJobDate;
      }
  
      return true;
    });
  }
  
 

    useEffect(() => {
      setAllEmployee([]);
      setFormData((prevData) => ({
        ...prevData,
        employeeId: null,
        order :id,
      }));

      if(formData.order ){
        if( formData.order !== '2'){
          fetchEmployeeData(formData.order);
        }else{ 
          fetchEmployeeData();
        }
      }
     }, [formData.order,id]);
  
  
  useEffect(() => {
  console.log('UserDetails',UserDetails.length)
  }, []);

  
  useEffect(() => {
    const newSubtotal = AddProduct.reduce((acc, item) => acc + (item.total || 0), 0);
    setSubtotal(newSubtotal);

    let totalTax = 0;

    AddProduct.forEach(item => {
      const baseAmount = item.quantity * item.amount;
      const taxRate = item.tax || 0;

      if (applyIGST) {
        totalTax += baseAmount * (taxRate / 100);
      } else {
        if (applyCGST) totalTax += baseAmount * (taxRate / 100) / 2;
        if (applySGST) totalTax += baseAmount * (taxRate / 100) / 2;
      }
    });

    setTaxTotal(totalTax);

    const calculatedFinalTotal = newSubtotal - discount + shipping ;
    setFinalTotal(calculatedFinalTotal >= 0 ? calculatedFinalTotal : 0);
  }, [AddProduct, discount, shipping, applyIGST, applyCGST, applySGST]);

  useEffect(() => {

  if (formData.PickupDate && formData.ReturnDate) {
    const pickupDate = new Date(formData.PickupDate);
    const returnDate = new Date(formData.ReturnDate);
    const diffTime = returnDate - pickupDate;
    const diffDays = diffTime / (1000 * 3600 * 24);
    setFormData((prevData) => ({
      ...prevData,
      diffDays:diffDays+1,
      days:diffDays+1,
    })); 
    }
}, [formData.PickupDate,formData.ReturnDate]);


  
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state



  const submitData = async () => {
    console.log('UserDetails',formData);
        console.log('AllEmployee',AllEmployee)
        console.log('hospitalId',formData.hospitalId)
 

const employee = AllEmployee.find(emp => emp._id === formData.employeeId);
console.log('AddProduct',AddProduct);
const hospitalId = formData?.hospitalId;

const hospitalMetaData =
  hospitalId
    ? AddProduct[0]?.employee?.data?.hospitalMeta?.[hospitalId] ?? []
    : [];

console.log('employee', employee);
console.log('hospitalMetaData', hospitalMetaData);


    if(formData.appoinment === ''){
        toast.error('Please select source');
        return null;
    }
    
   
    // Check if UserDetails is an object and has the necessary properties filled
    if (!UserDetails || Object.keys(UserDetails).length === 0 || 
        !UserDetails.name || 
        !UserDetails.phone || 
        !UserDetails.email || 
        !UserDetails.gender || !
        
        UserDetails.age) {
        
        toast.error('Please Fill in all user details');
        return null;
    }

    
    setSubmitLoading(false);
  
    let order = null;
    if(!formData.order){
      order = id;
    }else{
      order = formData.order;
    }
    let source = null;
 if(id === 3){
     source = formData.appoinment === 1 ? 'My Appointment' : 'Portal Appointment';
}

    const myFeatures = document.querySelectorAll(
      '#myFeatures input'
    );
    const FeaturesValues = Array.from(myFeatures).map((input) => input.value);


  const imageInputs = document.querySelectorAll(
    '#imageContainer input[type="hidden"]'
  );
  const inputValues = Array.from(imageInputs).map((input) => input.value);

  
   const updatedFormData = {
      ...formData,
      status: 1,
      addProduct: AddProduct,
      addRentalL: AddRental,
      addReceived: AddReceived,
      addReturn: AddReturn,
      discount: discount,
      shipping: shipping,
      applyIGST: applyIGST,
      applyCGST: applyCGST,
      applySGST: applySGST,
      userId : UserDetails?._id,
      UserDetails,
      subtotal,
      finalTotal,
      taxTotal,
      type : formData.order,
      addHistory: addHistory, // Combine old and new history
      prescription:FeaturesValues,
      images: inputValues,
     date: AddProduct[0]?.date,
     time: AddProduct[0]?.time, 
     floor: hospitalMetaData.floor ?? '',
     room: hospitalMetaData.room ?? '',
     doctor: AddProduct[0]?.doctor,
     employeeId : AddProduct[0]?.employeeId,
    };

    try {

      const response =  await axiosInstance.post('/admin/add-booking', updatedFormData);
      console.log('Booking Create successfully!');
     const {success,newOrder} = response.data;

      if(success){
   const sendmsg = { 
          ...newOrder,
            type: "appointment",
            subType: "add", 
             date: AddProduct[0]?.date,
     time: AddProduct[0]?.time, 
     floor: hospitalMetaData.floor,
     myroom: hospitalMetaData.room,
     doctor: AddProduct[0]?.doctor,
        }

      sendMessage(sendmsg); 
      toast.success('Booking Created successfully!');
      navigate(`/all-order-doctor`);
      
      }
     

      //  navigate(`/all-bookings`);

      // if(formData.order === '1'){
      //   navigate(`/all-order`);
      // }else if(formData.order === '2'){
      //   navigate('/all-order-rental');
      // }else if(formData.order === '3'){
      //   navigate('/all-order-doctor');
      // }else if(formData.order === '4'){
      //   navigate('/all-order-nurse');
      // }

    } catch (error) {
      console.error('Error On Creating Order:', error);
      console.log(formData);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const userOptions = AllUser.map(user => ({
    value: user._id,
    label: user.username
  }));

  const employeeSaleOptions = AllSaleEmployee.map(emp => ({
    value: emp._id,
    label: emp.username + ` (${emp.phone})` 
  }));

 const employeeHosOptions = AllHosEmployee.map(emp => ({
  value: emp._id,
  label: emp.username + ` (${emp.phone})` ,
 }));



  // Format employee list for react-select
const employeeOptions = filteredEmployees.map(emp => ({
  value: emp._id,
  label: emp.username + ` (${emp.phone})` ,
  schedule: emp.schedule ,
}));


  const generateDates = () => {
    const days = [];
    const today = new Date();
    for (let i = 0; i < Number(ExtendDate || 0); i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      const options = { weekday: "short", day: "2-digit", month: "short" };
      days.push({
        label: date.toLocaleDateString("en-IN", options), // e.g. Wed, 09 Jul
        value: date.toISOString().split("T")[0],          // yyyy-mm-dd
      });
    }
    return days;
  };



  const [ExtendDate, setExtendDate] = useState(10);            // days to generate

  const dates = useMemo(() => generateDates(), [ExtendDate]);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");

  
function addDaysToDate(dateStr, days) {
  console.log("Input dateStr:", dateStr);
  console.log("Days to add:", days);

  if (!dateStr || isNaN(days)) {
    console.warn("Invalid input to addDaysToDate");
    return "";
  }

  const cleanDateStr = dateStr.split(" ")[0];
  const [year, month, day] = cleanDateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + Number(days)); // Ensure days is treated as a number

  const result = date.toISOString().split("T")[0];
  console.log("Output date:", result);
  return result;
}
 
            const decryptdatajson = getDecryptData();

    useEffect(() => {
        const fetchData = async () => {

            if(decryptdatajson.type === 1 && decryptdatajson.empType === 3){
setFormData((prevData) => ({
    ...prevData,
     employeeId: decryptdatajson._id,
  }));
            }
              
            
        };

        fetchData();
    }, [AllEmployee]);
    

 
    
  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />


    <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
         
              <li className="breadcrumb-item active" aria-current="page">
                Add Appointment
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">Add Appointment  </h1>
            </div>
            <div>
              {" "}
              <Link
                type="button"
                to={'/all-order'}
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>
          </div>
        </div>
 

        <div
              className="modal fade"
              id="modal-user"
              tabIndex={-1}
              aria-labelledby="modal-user"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

                  <div className="row mb-0">
                      
                  <div className='col-md-6'> 
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="name" value={UserDetails.name}
     name="name" 
     onChange={handleUserDataChange}
      />
 </div>
</div>                   

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="email" value={UserDetails.email}
     name="email" 
     onChange={handleUserDataChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Phone <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="phone" value={UserDetails.phone}
     name="phone" 
     onChange={handleUserDataChange}
      />
 </div>
</div>   

 

<div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender  <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={UserDetails.gender}
                        name="gender"
                        onChange={handleUserDataChange}
                      >
                        <option selected value=""> 
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>


                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="Address"> Address  </label>

   <input
     type="text"
     className="form-control"
     id="address" value={UserDetails.address}
     name="address" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


 <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Weight  </label>

   <input
     type="text"
     className="form-control"
     id="weight" value={UserDetails.weight}
     name="weight" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="disease"> Disease    </label>

   <textarea
     type="text"
     className="form-control"
     id="disease" 
     name="disease" 
     onChange={handleUserDataChange}
      >{UserDetails.disease}</textarea>
 </div>
</div>  

                    </div>

                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-rental"
              tabIndex={-1}
              aria-labelledby="modal-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>


                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddRental}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-Received"
              tabIndex={-1}
              aria-labelledby="modal-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        

    { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 
              </>
                  }

                  
 {id === '4' && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}
    

                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReceived}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-Return"
              tabIndex={-1}
              aria-labelledby="modal-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReturn}
                    >
                      Add Return
                    </button>
                  </div>
                </div>
              </div>
            </div>



            <div
              className="modal fade"
              id="modal-edit-rental"
              tabIndex={-1}
              aria-labelledby="modal-edit-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateRental(formData.raindex)}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-edit-Received"
              tabIndex={-1}
              aria-labelledby="modal-edit-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        


            <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="days"> No. of days <span className='text-danger'>*</span>  </label>

<input
type="number"
className="form-control"
id="days" value={formData.days}
name="days" 
onChange={handleChange}
 
/>
</div>
</div> 


   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReceived(formData.raindex)}
                    >
                      Update Security
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-edit-Return"
              tabIndex={-1}
              aria-labelledby="modal-edit-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReturn(formData.raindex)}
                    >
                      Update Return
                    </button>
                  </div>
                </div>
              </div>
            </div>


 <div className='card p-3 mt-3'>
  {/* <h4> {id === '2' && 'Rental'} {formData.order === '1' && 'Order'}  {formData.order === '3' && 'Doctor Appointment'}  {formData.order === '4' && 'Nurse'} </h4>
 <hr className='my-1 p-0'/>
 */}

 <div className='row mt-4'>

{/* {!id && 
 <div className="mb-4">
 <div className='col-md-4'>

 <label htmlFor="eventTitle">
                     
                     Order Type
                   </label>{" "}

                   <select
                     className="form-control select"
                     name="order"
                     style={{ width: "100%" }} 
                      value={formData.order ? formData.order : id}
                      onChange={handleChange}
                   >
                     <option > Select type</option>
                     <option value={1} > Order</option>
                     <option value={2} > Rental </option>
                     <option value={3} > Doctors appointment </option>
                     <option value={4} > Nurse </option>
 
                     </select>

 </div> 
     </div>
} */}


<div className="row mb-0  mx-0 rounded mb-2">
                      
<div className='col-md-6'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Phones <span className='text-danger'>*</span>  </label>
    
       <input
         type="number"
         className="form-control"
         id="phone" value={UserDetails.phone}
         name="phone" 
         maxLength="10"
      onChange={(e) => {
    const value = e.target.value;
    // Allow only digits and up to 10 characters
    if (/^\d{0,10}$/.test(value)) {
      handleUserDataChange(e);
    }
  }}
         onWheel={(e) => e.target.blur()} // Use a function to handle the wheel event
         onKeyDown={(e) => {
           if (
             e.key === "ArrowUp" ||
             e.key === "ArrowDown"
           ) {
             e.preventDefault(); // Prevent the default action for up/down keys
           }
         }}
         
          />
     </div>
    </div>   
    

                      <div className='col-md-6'>
                 

     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="name" value={UserDetails.name}
         name="name" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>                   
    
    <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="email" value={UserDetails.email}
         name="email" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 
    
    <div className='col-md-3'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Age <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="age" value={UserDetails.age}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  
     
        
     <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Weight  </label>
    
       <input
         type="text"
         className="form-control"
         id="weight" value={UserDetails.weight}
         name="weight" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    
    <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Gender  <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.gender}
                            name="gender"
                            onChange={handleUserDataChange}
                          >
                            <option selected  value=''>
                          
                              Select Gender
                            </option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="0">Other</option>
                          </select>
                        </div>
                      </div>
    
      <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Do you have Company ? 
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.company}
                            name="company"
                            onChange={handleUserDataChange}
                          >
                            
                            <option value="yes">Yes</option>
                            <option value="no" selected>NO</option>
                           </select>
                        </div>
                      </div>
                     
                      {UserDetails.company === 'yes' && <>
 
                      <div className='col-md-12'/>
                      <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyName"> Company Name  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyName" value={UserDetails.companyName}
         name="companyName" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company GST  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyGST" value={UserDetails.companyGST}
         name="companyGST" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
        <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company Address  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyAddress" value={UserDetails.companyAddress}
         name="companyAddress" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 


                      </>}
    
                      <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="Address"> Address  </label>
    
       <textarea
         type="text"
         className="form-control"
         id="address" value={UserDetails.address}
         name="address" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
 
    
    <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="disease"> Disease    </label>
    
       <textarea
         type="text"
         className="form-control"
         id="disease" 
         name="disease" 
         onChange={handleUserDataChange}
          >{UserDetails.disease}</textarea>
     </div>
    </div>  
    
                        </div>

                       

{/* <div className='col-md-6 d-none'>
 
             

                            <div className="mb-4">
                      <label htmlFor="eventTitle">
                      
                        Choose User
                      </label>{" "}
                      

<div className='d-flex gap-3 align-items-center'>
 
                      <Select
    className="basic-single w-100"
    classNamePrefix="select "
    name="UserId"
    options={userOptions}
    value={userOptions.find(option => option.value === UserId)}
    onChange={(selectedOption) => {
      setUserId(selectedOption.value); // optional tracking
      handleUserChange(selectedOption.value);
    }}
    placeholder="Select User"
    isSearchable
  />
                    
                      {UserDetails && Object.keys(UserDetails).length > 0 && 
  <button className='btn btn-primary btn-sm w-auto' style={{ minWidth: 'max-content' }}
   data-bs-toggle="modal" data-bs-target="#modal-user"
  >
    View Details
  </button>
}
                      </div>

                    


                    </div>

                          </div> */}
              

              {((getAuth.type === 1 && getAuth.empType === 2) || getAuth.type === 0) &&
        
   <div className='col-md-4 d-none'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee ( Billing )
</label>{" "}

<Select
    name="employeeSaleId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeSaleOptions}
    value={employeeSaleOptions.find(option => option.value === formData.employeeSaleId)}
    onChange={(selectedOption) => {
      const event = {
        target: {
          name: 'employeeSaleId',
          value: selectedOption.value
        }
      };
      handleChange(event); // Reuse your existing handleChange logic
    }}
    placeholder="Select Employee"
    isSearchable
  />

</div>

</div>
       }


            {getAuth.type === 0 && 
 <div className='col-md-4 d-none'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Hospital
</label> 
  
  
  <Select
    name="hospitalId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeHosOptions}
    value={employeeHosOptions.find(option => option.value === formData.hospitalId)}
  onChange={(selectedOption) => {
  handleChange({
    target: {
      name: 'hospitalId',
      value: selectedOption ? selectedOption.value : ''
    }
  });
}}

    placeholder="Select Hospital"
    isSearchable
  />

  
</div>

</div>
}


 <div className='col-md-4'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Hospital
</label> 
  
  
  <Select
    name="hospitalId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeHosOptions}
    value={employeeHosOptions.find(option => option.value === formData.hospitalId)}
  onChange={(selectedOption) => {
  handleChange({
    target: {
      name: 'hospitalId',
      value: selectedOption ? selectedOption.value : ''
    }
  });
}}

    placeholder="Select Hospital"
    isSearchable
  />

  
</div>

</div>
 
  

<div className='col-md-4'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee ( Billing )
</label>{" "}

<Select
    name="employeeSaleId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeSaleOptions}
    value={employeeSaleOptions.find(option => option.value === formData.employeeSaleId)}
    onChange={(selectedOption) => {
      const event = {
        target: {
          name: 'employeeSaleId',
          value: selectedOption.value
        }
      };
      handleChange(event); // Reuse your existing handleChange logic
    }}
    placeholder="Select Employee"
    isSearchable
  />

</div>

</div>


   {/* Speciality */}
   
      {/* <div className="col-md-4">
        <label className="fw-semibold mb-2"> Choose Speciality</label>
        
              <Select
  className="border-0 w-100  "
  id="department"
  name="department"
  options={departments.map(item => ({
    label: item,  // Option label (text)
    value: item,   // Option value (ID)
  }))}
  value={departments.find(item => item === formData.department)  // Find the selected state
    ? {
        label: departments.find(item => item === formData.department),  // Display name of the state
        value: departments.find(item => item === formData.department),   // Use the state's ID as value
      }
    : null
  }
  onChange={(selectedOption) => handleChange({
    target: { name: "department", value: selectedOption?.value || "" }
  })}
  isClearable  // Optionally add a clear button
  placeholder={ "Select Department"}  // Change placeholder text to be more relevant
/>


              </div>  */}
   
 
{/*                 
<div className='col-md-4'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Doctor  
</label> 
<select
  className="form-control"
  value={AddProduct[0]?.employee?.value || ""}
  onChange={(e) => {
    console.log('AddProduct',AddProduct[0]?.employee?.value);
 
    console.log(e.target.value);
  }}
>
  <option value="">Select User</option>

  {AllProEmployee.map((emp) => (
    <option key={emp._id} value={emp._id} selected={AddProduct[0]?.employee?.value === emp._id }>
      {emp.username}
    </option>
  ))}
</select>


  <Select
    name="employeeId"
    className="basic-single"
    classNamePrefix="select"
    options={employeeOptions}
    value={formData.employeeId && employeeOptions.find(option => option.value === formData.employeeId)}
    onChange={(selectedOption) => {
      // Simulate native event to work with handleChange
      const event = {
        target: {
          name: 'employeeId',
          value: selectedOption.value,
         label: selectedOption.label,
         schedule: selectedOption.schedule,
        }
      };
      handleChange(event);
    }}
    placeholder="Select Doctor"
    isSearchable
  />  
  
</div>

</div>
  */}



  
  {/* <div className='col-12'>
     
     
    <SlotsSimple
      allSchedule={allSchedule}
      hosId={formData.hospitalId}
      onDaySelect={(dayObj) => {
        setFormData((prev) => ({ ...prev, day: dayObj.dayName }));
        setSelectedDate(dayObj.date);
      }}
      onSlotSelect={(slotValue) => {
        setSelectedTime(slotValue);
      }}
    />
    
 

  </div>
  
<hr/>
  */}



 {id === 'hide' &&
 <>

<div className='col-md-4'>
 
 <div className="mb-4">
   <label htmlFor="days">Days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="Days" value={formData.days}
     name="days" onChange={handleChange}
     min={formData.days}
     />
 </div>
</div>
 
                        <div className='col-md-4'>
 
 <div className="mb-4">
   <label htmlFor="name">
      {id === '4' ? 'DUTY Start Date' : id === '3' ? 'Appoinment Date' : 'Delivery Date'}
  <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="PickupDate" value={formData.PickupDate}
     name="PickupDate" onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

   />
 </div>
</div>

 <div className='col-md-3 mb-4'>

<label htmlFor="eventTime">
                    
                Appoinment  Time
                  </label> 
<input className="form-control" id="eventTime" type='time' value={formData.Ltime}  name="Ltime" onChange={handleChange} /> 

</div>

<div className='col-md-3 mb-4'>

<label htmlFor="source">
                    
                Appoinment Source
                  </label> 
<select className="form-control" id="appoinment" value={formData.appoinment}  name="appoinment" onChange={handleChange} >
   <option value={''} >Select Source
    </option>
  <option value={0}>YNB Appoinment
    </option>
      <option value={1}>My Appoinment
    </option>

    </select> 

</div>


{(id !== '1' && id !== '3') &&
<div className='col-md-4'>
 
 <div className="mb-4">
   <label htmlFor="name"> Renewal Date  <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="ReturnDate" 
     value={formData.ReturnDate}
     onChange={handleChange}
     name="ReturnDate"  
     min={formData.PickupDate}
      />
<br/>
     <p className='bg-warning mt-2 px-3 py-1 rounded-3 text-dark w-auto d-inline'> No. of days - {formData.diffDays} </p>
 </div>
</div>
 }

{ id !== '1' && 
<div className={`col-md-6 ${id !== '4'  && 'd-none '}`}>
 
 <div className="mb-4">
   <label htmlFor="name"> Duty Hours  <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="dutyHr" 
     value={formData.dutyHr}
     onChange={handleChange}
     name="dutyHr"  
       />
 
  </div>
</div>
}



{( id !== '1' && id !== '3' )  && 
<>


<div className={`col-md-6 ${id === '4' && 'd-none '}`}>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt">Security Amt   </label>

   <input
     type="number"
     className="form-control"
     id="SecurityAmt" value={formData.SecurityAmt}
     name="SecurityAmt" onChange={handleChange}
     min={formData.SecurityAmt}
     />
 </div>
</div>

<div className={`col-md-6 ${id === '4' && 'd-none '}`}>
 
 <div className="mb-4">
   <label htmlFor="AdvanceAmt"> Advance Money   </label>

   <input
     type="number"
     className="form-control"
     id="AdvanceAmt" value={formData.AdvanceAmt}
     name="AdvanceAmt" onChange={handleChange}
     min={formData.SecurityAmt}
     />
 </div>
</div>

{id !== '4' && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="OnBoardDate">
       Client on Boarding Date

  <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="OnBoardDate" value={formData.OnBoardDate}
     name="OnBoardDate" onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates
     />
 </div>
</div>
 } 

</>
}




 </>


}



<div className='col-md-12 mb-2'>
              {/* Search */}
                  <div
                    className={`input-group d-flex me-5 w-500 searchbox flex-fill ${!showSearch && "search-view"
                      } `}
                    style={{ backgroundColor: "#f3f7fb" }}
                  >
                    <input
                      id="searchInput"
                      className="form-control searchinput"
                      type="text"
                      placeholder="Search for products,category and more"
                      value={searchQuery}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      className="btn btn-primary bg-gradient d-none d-lg-block search  text-secondary"
                    >
                      <i className="ri-search-line fw-bold" />
                    </button>
  
             
                    {searchQuery && (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary bg-gradient d-none d-lg-block close"
                          onClick={handleClearClick}
                        >
                          {" "}
                          <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                        </button>
                      </>
                    )}
                  </div>

                  {searchQuery && (
                      <>
                        <ul class="searchfloat mt-3 p-0">
                          {searchQuery &&
                            filteredProducts &&
                            filteredProducts.map((item) => {
                              console.log("item.slug", item.slug);
                              const myslug =  item._id; // Make sure `data` and `Product` are defined and available in the scope.
                              return (
                                <li key={item.id} className='d-block'>
                                  <Link 
                                    onClick={()=> handleAddProduct(item)}
                                  > 
                                    <i class="ri-shopping-bag-line"></i>{" "}
                                    {item.title} 
                                   
  
                                  </Link>
                                </li>
                              );
                            })}
                        
                        </ul>
                      </>
                    )}
  

                  {/* Search */}

</div>

<div className='col-md-12 '>

  
 <div className="table-responsive border border-bottom-0 rounded-4">
  <table className="table align-middle table-hover mb-0">
    <thead className="table-light">
      <tr>
        <th style={{ width: 60 }}>#</th>
        <th>Product</th>
        <th style={{ width: 140 }}>Price</th>
        <th style={{ width: 120 }}>Qty</th>
        <th style={{ width: 160 }} className="text-end">Total</th>
        <th style={{ minWidth: 240 }}>Assign</th>
        <th style={{ width: 80 }} className="text-end">Action</th>
      </tr>
    </thead>

    <tbody>
      {AddProduct.length > 0 ? (
        AddProduct.map((product, index) => (
          <tr key={product.id || index}>
            {/* Index */}
            <td>
              <span className="badge bg-primary">{index + 1}</span>
            </td>

            {/* Title */}
            <td>
              {id === "3" ? (
                <textarea
                  className="form-control form-control-sm"
                  value={product.title}
                  onChange={(e) => handleTitleChange(index, e.target.value)}
                  rows={2}
                  style={{ minWidth: 220 }}
                />
              ) : (
                <div className="fw-semibold">{product.title}</div>
              )}
            </td>

            {/* Price */}
            <td>
              <input
                type="number"
                className="form-control form-control-sm"
                value={product.amount}
                onChange={(e) => handleAmtChange(index, e.target.value)}
                placeholder="Price"
              />
            </td>

            {/* Qty */}
            <td>
              <input
                type="number"
                className="form-control form-control-sm"
                value={product.quantity}
                onChange={(e) => handleQuantityChange(index, e.target.value)}
                placeholder="Qty"
              />
            </td>

            {/* Total */}
            <td className="text-end">
              <div className="fw-bold">₹ {Number(product.total || 0).toFixed(2)}</div>
              <small className="text-muted">Auto calculated</small>
            </td>

            {/* Employee Select */}
            <td>
            <Select
  options={product.employeeOptions}
  value={product.employee ?? ''}
  onChange={(val) => handleEmployeeChange(index, val)}
  placeholder="Assign Employee"
  classNamePrefix="react-select-sm"

  menuPortalTarget={document.body}
  menuPosition="fixed"

  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
    menu: (base) => ({ ...base, zIndex: 999999 }),
  }}
/>
{/* Date & Time Badge */}
{(product.date || product.time) ? (
  <div className="mt-2 d-flex align-items-center flex-wrap gap-1">
    <div
      style={{
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: "var(--bs-secondary-color)",
        width: "100%",
        marginBottom: 2,
      }}
    >
      Scheduled
    </div>

    {product.date && (
      <span
        className="d-inline-flex align-items-center gap-1"
        style={{
          background: "#E6F1FB",
          color: "#0C447C",
          fontSize: 12,
          fontWeight: 500,
          padding: "3px 8px",
          borderRadius: 6,
        }}
      >
        <i className="ri-calendar-line" style={{ fontSize: 12 }}></i>
        {new Date(product.date).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    )}

    {product.time && (
      <span
        className="d-inline-flex align-items-center gap-1"
        style={{
          background: "#EAF3DE",
          color: "#3B6D11",
          fontSize: 12,
          fontWeight: 500,
          padding: "3px 8px",
          borderRadius: 6,
        }}
      >
        <i className="ri-time-line" style={{ fontSize: 12 }}></i>
        {product.time.replace(" - ", " – ")}
      </span>
    )}
  </div>
) : (
  <div
    className="mt-2"
    style={{ fontSize: 12, color: "var(--bs-secondary-color)", fontStyle: "italic" }}
  >
    No schedule assigned
  </div>
)}

            </td>

            {/* Action */}
            <td className="text-end">
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => handleRemoveProduct(index)}
                title="Remove"
              >
                <i className="ri-delete-bin-line"></i>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center py-4 text-muted">
            No products added
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>


  {/* <div className='overflow-auto d-none'>
  <table className="table table-bordered mt-3">
  <thead>
    <tr>
      <th>#</th>
       <th>Name</th>
      <th>Price</th>
      <th>Quantity</th>
 
      
      <th>Tax (%)</th>
      <th>Total Amount</th>
       <th>Employee</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {AddProduct.length > 0 ? (
      AddProduct.map((product, index) => (
        <tr key={product.id || index}>
          <td>{index + 1}</td>
           <td style={{Width:'100%'}} > <p style={{width:150,whiteSpace:'normal'}}>
            
            {id === '3' ?  <textarea
            type="text"
             className="form-control p-1 shadow-none"
            value={product.title}
            onChange={(e) => handleTitleChange(index, e.target.value)}
          /> :  product.title
            } 
             
           </p></td>
          <td style={{minWidth:150,maxWidth:80}} >
          <input
              type="number"
                className="form-control"
              value={product.amount}
              onChange={(e) => handleAmtChange(index, e.target.value)}
            />
           </td>
           

          <td style={{Width:80,maxWidth:80}} >
            <input
              type="number"
              min="1"
              className="form-control"
              value={product.quantity}
              onChange={(e) => handleQuantityChange(index, e.target.value)}
            />
          </td>
         

          <td style={{ minWidth: 100,width:100 }}>
          <input
            type="number"
            className="form-control px-1 text-center"
            value={product.tax || 0}
            onChange={(e) => handleTaxChange(index, e.target.value)}
          />
        </td>
          <td style={{Width:80,maxWidth:80}} >
          ₹ {product.total.toFixed(2)}
              
          </td>

          <td>
    <Select
      options={product.employeeOptions}
      value={product.employee}
      onChange={(val) => handleEmployeeChange(index, val)}
      placeholder="Select Employee"
    />
  </td>
   

          <td style={{Width:80,maxWidth:80}} >   <button
              className="btn btn-danger btn-sm"
              onClick={() => handleRemoveProduct(index)}
            >
              <i className="ri-delete-bin-line"></i> Delete
            </button>
            </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center">No products added</td>
      </tr>
    )}
  </tbody>
</table>
  </div> */}
  {AddProduct.length > 0 && (
<div className='col-md-4 ms-auto mt-3 '>

<table className="table table-bordered rounded-4 overflow-hidden border border-black shadow">
    <tbody>
      <tr>
        <th>Subtotal:</th>
        <td>₹ {subtotal.toFixed(2)}</td>
      </tr>

      
   
      <tr>
        <th>Discount:</th>
        <td>
          <input
            type="number"
            className="form-control"
            value={discount}
            onChange={handleDiscountChange}
            min="0"
          />
        </td>
      </tr>
       
      <tr>
        <th>Shipping:</th>
        <td>
          <input
            type="number"
            className="form-control"
            value={shipping}
            onChange={handleShippingChange}
            min="0"
          />
        </td>
      </tr>
      <tr>
      
      
      <th>Tax {applyIGST ? '(IGST)' : '(CGST + SGST)'}: <hr/>
      <div className="d-block gap-3 mb-3">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="igstCheck"
            checked={applyIGST}
            onChange={() => {
              setApplyIGST(!applyIGST);
              if (!applyIGST) {
                setApplyCGST(false);
                setApplySGST(false);
              }
            }}
          />
          <label className="form-check-label" htmlFor="igstCheck">Apply IGST</label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="cgstCheck"
            checked={applyCGST}
            onChange={() => {
              setApplyCGST(!applyCGST);
              if (!applyCGST) setApplyIGST(false);
            }}
          />
          <label className="form-check-label" htmlFor="cgstCheck">Apply CGST</label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="sgstCheck"
            checked={applySGST}
            onChange={() => {
              setApplySGST(!applySGST);
              if (!applySGST) setApplyIGST(false);
            }}
          />
          <label className="form-check-label" htmlFor="sgstCheck">Apply SGST</label>
        </div>
      </div>
      </th>

      <td>  ₹ {(applyIGST || applyCGST || applySGST) ? taxTotal.toFixed(2) : 0.00} </td>
 </tr>

      <tr>
        <th>Final Total:</th>
        <td><strong>₹ {finalTotal.toFixed(2)}</strong></td>
      </tr>
    </tbody>
  </table>
  
  </div>
  )}

</div>


 




{ id === '3' && 
<>

  <div className="col-lg-4">
                                                  <Gallery />
                                                </div>


  <div className="col-md-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="KeyFeatures"
                                  className="d-block mb-2"
                                >
                                  Key Prescription
                                </label>

                                <div id="myFeatures">
                                  {formData.features && (
                                    <>
                                      {formData.features.map(
                                        (features, index) => (
                                          <div
                                            className="col-md-12 mb-2 d-flex gap-2"
                                            key={index}
                                          >
                                            <input
                                              type="text"
                                              className="form-control"
                                              id={`Features${index + 1}`}
                                              placeholder="Type Prescription"
                                              name="productImg[]"
                                              value={features}
                                            />

                                            <button
                                              className="btn btn-danger d-block m-auto"
                                              onClick={removeFeatures}
                                            >
                                              Delete
                                            </button>
                                            <br />
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}

                                  {Features.map((Features, index) => (
                                    <React.Fragment key={index}>
                                      {Features}
                                    </React.Fragment>
                                  ))}
                                </div>

                                <button
                                  onClick={addFeatures}
                                  className="btn btn-secondary btn-sm"
                                  type="button"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#1f2937"
                                    stroke-width="2"
                                    stroke-linecap="square"
                                    stroke-linejoin="arcs"
                                  >
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                  Add Prescription
                                </button>
                              </div>
                            </div>

                             
                        <div className="col-md-12">
                          <button
                            onClick={addImageDiv}
                            className="btn btn-secondary btn-sm"
                            type="button"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="mx-1"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#1f2937"
                              stroke-width="1.5"
                              stroke-linecap="square"
                              stroke-linejoin="arcs"
                            >
                              <rect x="3" y="3" width="18" height="18" rx="2" />
                              <circle cx="8.5" cy="8.5" r="1.5" />
                              <path d="M20.4 14.5L16 10 4 20" />
                            </svg>
                            Add Image
                          </button>
                          <div id="imageContainer" className="row mt-3">

                            {imageDivs.map((imageDiv, index) => (
                              <React.Fragment key={index}>
                                {imageDiv}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                        
                        </>


}

        


{( id === 'hide' ) &&  <>

 
<div className={`col-md-12 my-4 ${id === '4' && 'd-none'}`}>
<div className='d-flex justify-content-between'>
<h4>Rental Amount  </h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-rental"  >Add Rental</button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th>

  </tr>
</thead>
<tbody>
  {AddRental.length > 0 ? (
    AddRental.map((rental, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
          <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
          <td>{rental.method}</td>
         <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
         <td style={{Width:80,maxWidth:80}} > <p  style={{
    maxWidth: '80px',
    whiteSpace: 'break-spaces',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
    padding:'0px',
  }} >{rental.comment }
      </p> 
         </td>
        <td style={{Width:80,maxWidth:80}} > 
        <button
            className="btn btn-primary btn-sm me-2"
            onClick={() => handleEditRental(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-rental"
          >
            <i className="ri-pencil-fill"></i>  
          </button>
            <button
            className="btn btn-danger btn-sm"
            onClick={() => handleRemoveRental(index)}
          >
            <i className="ri-delete-bin-line"></i>  
          </button>
          </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Rental Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddRental.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddRental.reduce((acc, rental) => acc + parseFloat(rental.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>
 
<div className='col-md-12 my-4'>
<div className='d-flex justify-content-between'>
<h4>
  {id === '4' ? 'Payment Mangement' : 'Security Details' }
</h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-Received"  >{id === '4' ? 'Add Payment' : 'Add Security Details' } </button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
  <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
 {id === '4' && <th>Days	</th> }
    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th> 
  </tr>
</thead>
<tbody>
  {AddReceived.length > 0 ? (
    AddReceived.map((rental, index) => (
      <tr key={index}>
      <td>{index + 1}</td>
       <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
        <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
        <td>{rental.method}</td>
         {id === '4' && <td>{rental.days !== '' ? rental.days : 'NA' }	</td> }

       <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
       <td style={{Width:80,maxWidth:80}} > <p  style={{
  maxWidth: '80px',
  whiteSpace: 'break-spaces',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  padding:'0px',
}} >{rental.comment }
    </p> 
       </td>
      <td style={{Width:80,maxWidth:80}} > 
      <button
          className="btn btn-primary btn-sm me-2"
          onClick={() => handleEditReceived(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-Received"
        >
          <i className="ri-pencil-fill"></i>  
        </button>
          <button
          className="btn btn-danger btn-sm"
          onClick={() => handleRemoveReceived(index)}
        >
          <i className="ri-delete-bin-line"></i>  
        </button>
        </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Received Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddReceived.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddReceived.reduce((acc, data) => acc + parseFloat(data.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>
 
<div className={`col-md-12 my-4  ${id === '4' && 'd-none'}`}>
<div className='d-flex justify-content-between'>
<h4> Security Return Details
</h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-Return"  >Add Security Return</button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
  <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th>
  </tr>
</thead>
<tbody>
  {AddReturn.length > 0 ? (
    AddReturn.map((rental, index) => (
      <tr key={index}>
      <td>{index + 1}</td>
       <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
        <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
        <td>{rental.method}</td>
       <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
       <td style={{Width:80,maxWidth:80}} > <p  style={{
  maxWidth: '80px',
  whiteSpace: 'break-spaces',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  padding:'0px',
}} >{rental.comment }
    </p> 
       </td>
      <td style={{Width:80,maxWidth:80}} > 
      <button
          className="btn btn-primary btn-sm me-2"
          onClick={() => handleEditReturn(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-rental"
        >
          <i className="ri-pencil-fill"></i>  
        </button>
          <button
          className="btn btn-danger btn-sm"
          onClick={() => handleRemoveReturn(index)}
        >
          <i className="ri-delete-bin-line"></i>  
        </button>
        </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Return Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddReturn.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddReturn.reduce((acc, data) => acc + parseFloat(data.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>

</>
}


<div className='col-md-12 my-4'>
<div className='d-flex justify-content-between'>
<h4>History
</h4>
 </div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
    <th>Time</th>
    <th>User details</th>
    <th> Changes </th>
    <th> Commnent </th>
 
  </tr>
</thead>
<tbody>
  {addHistory.length > 0 ? (
    addHistory.map((data, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{data.date}</td>
         <td>{data.time}</td>
         <td>Username: {data.name}  
         </td>
          <td>{data.changes}</td>
         <td>{data.comment }</td>
          
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No History Found</td>
    </tr>
  )}
</tbody>
</table>
</div>
 

</div>


<div className="col-12 mt-4">

{SubmitLoading ? (

  <button className="btn btn-secondary" type="button" onClick={submitData} >
    Create Appointment
  </button>
) : (

  <button class="btn btn-secondary btn-sm" type="button" disabled>
    <span class="ms-1">Loading...</span>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>

)}


</div>



      </div>

 </div>
   

      </main>
    </>
  )
}

export default OrderCreateAppointment